<template lang="html">

  <div>
    <v-parallax src="./images/parrallax/18.png" height='800'>
      <v-layout align-center justify-center row wrap>
        <v-flex xs10 md12>
          <div class='text-center'>
            <p class='display-3 font-weight-medium text-center blue--text text--darken-3'>Pricing</p>
            <v-layout row wrap justify-center fill-height>
              <v-flex md8>
              <v-layout row wrap justify-center fill-height>
              <v-flex xs10 sm6 md4 lg3 text-center ma-5 hidden-sm-and-down>
                <v-card>
                  <v-card-title class='xs12 justify-center font-weight-medium display-1 pt-2'>
                    Lite
                  </v-card-title>
                  <v-card-text>

                    <h3 class='display-1 font-weight-medium light-blue--text text--darken-3'>$49</h3>
                    <h3 class='font-weight-medium'>Per Month<br> $999 Setup/Installation</h3>
                    <v-divider class='hidden-sm-and-down'></v-divider>
                    <p class='hidden-sm-and-down'>
                Engage Desktop<br>Engage Mobile<br><b>500</b> Outgoing Messages <br><b>Unlimited</b> Contacts<br><b>Unlimited</b> Incoming<br>Single User<br><br/><br/><br/>
                    </p>
                    <v-divider class='hidden-sm-and-down'></v-divider>
                    <p class='pa-1'>
                      <span class='font-weight-medium'>Additional Fees</span> <br> $20 Per Month +1000 Messages
                    </p>
                    <v-btn
                      tile
                      color="primary"
                      @click="popWindow('/pdf/engage_orderform.pdf')" >Sign Up</v-btn>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs10 sm6 md4 lg3 text-center ma-5>
                <v-card>

                  <v-card-title class='xs12 justify-center font-weight-medium display-1 pt-2'>
                    Standard
                  </v-card-title>
                  <v-card-text>
                    <h3 class='display-1 font-weight-medium light-blue--text text--darken-3'>$99</h3>
                    <h3 class='font-weight-medium'>Per Month<br> $999 Setup/Installation</h3>
                    <v-divider></v-divider>
                    <p>
                      Engage Desktop<br>Engage Mobile<br>Engage Web Widget<br><b>1000</b> Outgoing Messages <br><b>Unlimited</b> Preset Messages<br/><b>Unlimited</b> Contacts<br>            <b>Unlimited</b> Incoming<br> <b>Unlimited</b> Users<br>MMS Support<br>
                    </p>
                    <v-divider></v-divider>
                    <p class='pa-1'>
                      <span class='font-weight-medium'>Additional Fees</span> <br> $20 Per Month +1000 Messages
                    </p>
                    <v-btn
                      tile
                      color="primary"
                      @click="popWindow('/pdf/engage_orderform.pdf')">Sign Up</v-btn>
                  </v-card-text>
                </v-card>
              </v-flex>

              <v-flex xs10 sm6 md4 lg3 text-center ma-5 hidden-sm-and-down>
                <v-card>
                  <v-card-title class='xs12 justify-center font-weight-medium display-1 pt-2'>
                    Professional
                  </v-card-title>
                  <v-card-text>
                    <h3 class='display-1 font-weight-medium light-blue--text text--darken-3'>$129</h3>
                    <h3 class='font-weight-medium'>Per Month<br> $999 Setup/Installation</h3>
                    <v-divider class='hidden-sm-and-down'></v-divider>
                    <p class='hidden-sm-and-down'>
                      Engage Desktop<br>Engage Mobile<br>Engage Web Widget<br><b>3000</b> Outgoing Messages <br><b>Unlimited</b> Preset Messages<br/><b>Unlimited</b> Contacts<br><b>Unlimited</b>            Incoming<br> <b>Unlimited</b> Users<br> MMS Support
                    </p>
                    <v-divider class='hidden-sm-and-down'></v-divider>
                    <p class='pa-1'>
                      <span class='font-weight-medium'>Additional Fees</span> <br> $20 Per Month +1000 Messages
                    </p>
                    <v-btn
                      tile
                      color="primary"
                      @click="popWindow('/pdf/engage_orderform.pdf')" >Sign Up</v-btn>
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
            </v-flex>
            </v-layout>
          </div>
        </v-flex>
      </v-layout>
    </v-parallax>

    <v-layout row wrap justify-center>
      <v-flex xs12 sm10 md8 pa-5>
        <v-layout row wrap justify-center pa-5 text-center>
          <v-flex xs10 sm10 md4 pa-5 :key="index" v-for="(channel, index) in channels">
            <v-layout row wrap align-center justify-center pa-5>
              <v-flex xs12 text-xs-center>
                <v-icon size="100" color='light-blue'>{{ channel.icon }}</v-icon>
              </v-flex>
              <v-flex xs12 sm12>
                <h3 class="headline black--text">{{ channel.headline}}</h3>
              </v-flex>
              <v-flex xs12 sm12 pl-5 pr-5 class='black--text'>
                {{ channel.desc }}
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-parallax src="./images/parrallax/18.png" height='600' class='hidden-sm-and-down'>

    <v-layout row wrap align-center justify-center fill-height pa-5>
      <v-flex xs11 md8>
        <v-card>
          <v-simple-table fixed-header height='500'>
            <thead>
              <tr>
                <th class="text-left font-weight-medium display-1 white--text MA-5" style="background-color:#0D47A1">Included Features</th>
                <th class="text-center pa-5" style="background-color:#0D47A1">
                  <h3 class='font-weight-medium display-1 white--text'>Standard</h3>
                  <h3 class='headline font-weight-medium light-blue--text'>$99</h3>
                  <h3 class='font-weight-regular pb-2 white--text'>Per Month<br> $999 Setup/Installation</h3>
                  <v-btn tile color="primary">Sign Up</v-btn>
                </th>

              </tr>
            </thead>
            <tbody>
              <tr :key="index" v-for="(ftable, index) in ftable">
                <td>
                  <div class='subtitle-2'>{{ ftable.feature }}</div>
                  {{ ftable.desc }}
                </td>
                <td class="text-center">
                  <v-icon color='green'>{{ ftable.icon }}</v-icon>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-flex>
    </v-layout>
</v-parallax>
  </div>

</template>

<script>

  export default {
    data() {
      return {
        channels: [
          {
            headline: 'Monthly Subscription',
            desc: 'No Contracts, No commitment. Cancel Anytime',
            icon: 'business'
          },
          {
            headline: 'Unlimited Incoming Messages',
            desc: 'Recieve every message from your customer at no charge.',
            icon: 'people'
          },
          {
            headline: 'Improve Communication',
            desc: '58% of consumers have tried to reply to a missed call via text.',
            icon: 'sms'
          }
        ],
        ftable: [
          {
            feature: 'Engage Desktop Application',
            icon: 'check',
            desc: 'Access Engage right from your desktop or laptop pc anywhere you have internet access.'
          },
          {
            feature: 'Android and iOS Mobile Application',
            icon: 'check',
            desc: 'Mobile ready applications give you access on the go from your mobile device.'
          },
          {
            feature: 'Website Widget',
            icon: 'check',
            desc: 'Be where your customers are, Engage web widget allows your customers to text you right from your website.'
          },
          {
            feature: 'MMS Media Support',
            icon: 'check',
            desc: 'Send and recieve images creating a rich communication experience.'
          },
          {
            feature: 'Notifications',
            icon: 'check',
            desc: 'Keep on top of incoming messages with notifications on desktop and mobile.'
          },
          {
            feature: 'Active Web Sockets',
            icon: 'check',
            desc: 'No need to refresh as Engage automatically detects updates.'
          },
          {
            feature: 'Archived Conversations',
            icon: 'check',
            desc: 'Organize your conversations and keep old conversations for reference.'
          },
          {
            feature: 'Conversation Filter',
            icon: 'check',
            desc: 'Close in on your focused conversations with the use of filters.'
          },
          {
            feature: 'Conversation Search',
            icon: 'check',
            desc: 'Locate conversations quickly and easily.'
          },
          {
            feature: 'Conversation Color Categories',
            icon: 'check',
            desc: 'Color classify your conversations.'
          },
          {
            feature: 'Conversation Notes',
            icon: 'check',
            desc: 'Keep notes on the important details you dont want to forget.'
          },
          {
            feature: 'Unlimited Preset Messages',
            icon: 'check',
            desc: 'Keep a professional and consistent message no matter who is responding.'
          },
          {
            feature: 'Unlimited Users',
            icon: 'check',
            desc: 'No matter the size of your staff provide them the tools to succeed.'
          },
          {
            feature: 'Unlimited Contacts',
            icon: 'check',
            desc: 'Engage grows with your customer base.'
          },
          {
            feature: 'Multi Location Support',
            icon: 'check',
            desc: 'Manage and access multiple locations with one login.'
          },
          {
            feature: 'SummitCRS Integration',
            icon: 'check',
            desc: 'Integration with Summit Collision Repair System keeping your customers updated.'
          },
          {
            feature: '3rd Party API Support',
            icon: 'check',
            desc: 'Our simple API allows 3rd party applications to utilize the power of Engage.'
          }
        ],
        faq: [
          {
            question: 'Can I use this on my mobile device',
            answer: 'Engage is fully compatible with Apple iOS and Android.'
          },
          {
            question: 'Does my business get a specific phone number',
            answer: 'Yes, you will be provided with an SMS number unique to your business.'
          },
          {
            question: 'How long before I can start using Engage',
            answer: 'After receiving your order the Engage Messaging Platform is available in 1-2 business days.'
          },
          {
            question: 'Is there a contract',
            answer: 'Engage is a month to month subscription based service, cancel at any time.'
          },
          {
            question: 'Do I get charged for incoming messages',
            answer:
              'Incoming messages do not cost you anything, a standard subscription will provide 1000 outgoing text messages a month with the option to add an addtional 1000 each month for just $20.'
          },
          {
            question: 'Can I adjust my plan for more messages',
            answer:
              'The standard plan for Engage includes 1000 messages for each additional 1000 you simply add $20 to your monthly subscription fee.'
          }
        ]
      }
    },
    methods: {
      popWindow(url) {
        window.open(url)
        }
      }
  }

</script>

<style lang="css" scoped>
</style>
